import { X } from 'lucide-react'
import React, { useState } from 'react'
import { useGameSettings } from '../../slotGame/slotData'

const SystemSettings = ({ onClose, bet, setBet, turboOn, setTurboOn, soundOn, setSoundOn, ambientMusic, setAmbientMusic, setShowHistory, setVolume, balance }) => {

  const { minBet, maxBet } = useGameSettings()
  const [batterySaver, setBatterySaver] = useState(false)

  return (
    <div className="flex flex-col w-full h-full mx-auto text-white">
      <div className="w-full h-[15%] flex items-center justify-center relative text-lg md:text-xl lg:text-2xl 2xl:text-3xl 3xl:text-5xl font-bold border-b border-gray-500">
        <span className="absolute left-1/2 transform -translate-x-1/2">System Settings </span>
        <button
          className="absolute right-4 text-gray-50 bg-slate-700 p-1 hover:text-gray-300 text-xl rounded-full"
          onClick={onClose}
        >
          <X className="xs:w-2 xs:h-2 sm:w-3 sm:h-3 md:w-4 md:h-4 lg:w-7 lg:h-7 2xl:w-9 2xl:h-9 3xl:w-12 3xl:h-12" />
        </button>
      </div>
      <div className="grid grid-cols-12 gap-4 h-[85%] items-center m-2">
        <div className="col-span-5 xs:px-2 md:px-5 xl:px-16 py-3 flex flex-col">
          <div className='border-y border-gray-200 xs:p-2 2xl:p-4 flex flex-row items-center justify-between font-bold xs:text-sm md:text-lg xl:text-xl 3xl:text-3xl'>
            Game History
            <div
              className='xs:w-5 xs:h-5 md:w-8 md:h-8 3xl:w-16 3xl:h-16'
              style={{
                backgroundImage: "url('/export.png')",
                backgroundSize: "cover",
                backgroundPosition: 'center',
              }}
              onClick={() => {
                onClose();
                setShowHistory(true)
              }}
            ></div>
          </div>
          <div className='flex flex-col w-full mt-4'>
            <div className='flex items-start xs:text-base 2xl:text-2xl'>Total Bet</div>
            <div className='flex items-center justify-between xs:mt-1 xl:mt-4'>
              <div className='flex items-center justify-center xs:w-5 xs:h-5 md:w-8 md:h-8 xl:w-12 xl:h-12 3xl:h-20 3xl:w-20'
                style={{
                  backgroundImage: "url('/minus-white.png')",
                  backgroundSize: "cover",
                  backgroundPosition: 'center'
                }}
                onClick={() => {
                  if (bet - 1 >= minBet) {
                    setBet(bet - 1)
                  }
                }}
              ></div>
              <div className='xs:py-1 3xl:p-4 border w-[60%] mx-1 border-gray-200 bg-gray-700 rounded-lg flex items-center justify-center xs:text-md md:text-lg xl:text-2xl 3xl:text-4xl'>{bet?.toFixed(2)}</div>
              <div className='flex items-center justify-center xs:w-5 xs:h-5 md:w-8 md:h-8 xl:w-12 xl:h-12 3xl:h-20 3xl:w-20'
                style={{
                  backgroundImage: "url('/plus-green.png')",
                  backgroundSize: "cover",
                  backgroundPosition: 'center'
                }}
                onClick={() => {
                  // if (bet + 1 <= maxBet && bet + 1 <= balance) {
                  //   setBet(bet + 1)
                  // }
                  if (bet + 1 <= maxBet) {
                    setBet(bet + 1)
                  }
                }}
              ></div>
            </div>

          </div>
        </div>

        <div className="col-span-7 flex flex-col items-center xs:p-1 lg:p-5">

          <div className='w-full flex flex-row xs:py-2 md:py-3 2xl:py-4'>
            <div className='w-[75%] flex flex-col items-start'>
              <div className='font-bold xs:text-sm md:text-lg xl:text-xl 3xl:text-4xl xs:py-0 md:py-2 xl:py-2'>Quick Spin</div>
              <div className='xs:text-[0.55rem] md:text-md xl:text-lg 2xl:text-2xl 3xl:text-3xl'>Play faster by reducing total spin time</div>
            </div>
            <div className='w-[25%] bg-center bg-no-repeat bg-contain'
              style={{
                backgroundImage: `url(${turboOn ? '/on.png' : '/off.png'})`,
                backgroundSize: "70% 80%",
              }}
              onClick={() => { setTurboOn(!turboOn) }}
            ></div>
          </div>

          <div className='w-full flex flex-row xs:py-2 md:py-3 2xl:py-4'>
            <div className='w-[75%] flex flex-col items-start'>
              <div className='font-bold xs:text-sm md:text-lg xl:text-xl 3xl:text-4xl xs:py-0 md:py-2 xl:py-2'>Battery Saver</div>
              <div className='xs:text-[0.55rem] md:text-[0.68rem] xl:text-lg 2xl:text-[1.3rem] 3xl:text-3xl'>Save battery life by reducing animation speed</div>
            </div>
            <div className='w-[25%] bg-center bg-no-repeat bg-contain'
              style={{
                backgroundImage: `url(${batterySaver ? '/on.png' : '/off.png'})`,
                backgroundSize: "70% 80%",
              }}
              onClick={() => { setBatterySaver(!batterySaver) }}
            ></div>
          </div>

          <div className='w-full flex flex-row xs:py-2 md:py-3 2xl:py-4'>
            <div className='w-[75%] flex flex-col items-start'>
              <div className='font-bold xs:text-sm md:text-lg xl:text-xl 3xl:text-4xl xs:py-0 md:py-2 xl:py-2'>Ambient Music</div>
              <div className='xs:text-xs md:text-md xl:text-lg 2xl:text-2xl 3xl:text-3xl'>Turn On or Off The game music</div>
            </div>
            <div className='w-[25%] bg-center bg-no-repeat bg-contain'
              style={{
                backgroundImage: `url(${ambientMusic ? '/on.png' : '/off.png'})`,
                backgroundSize: "70% 80%",
              }}
              onClick={() => { setAmbientMusic(!ambientMusic); setVolume(10) }}
            ></div>
          </div>

          <div className='w-full flex flex-row xs:py-2 md:py-3 2xl:py-4'>
            <div className='w-[75%] flex flex-col items-start'>
              <div className='font-bold xs:text-sm md:text-lg xl:text-xl 3xl:text-4xl xs:py-0 md:py-2 xl:py-2'>Sound Fx</div>
              <div className='xs:text-xs md:text-md xl:text-lg 2xl:text-2xl 3xl:text-3xl'>Turn On or Off The game sounds</div>
            </div>
            <div className='w-[25%] bg-center bg-no-repeat bg-contain'
              style={{
                backgroundImage: `url(${soundOn ? '/on.png' : '/off.png'})`,
                backgroundSize: "70% 80%",
              }}
              onClick={() => { setSoundOn(!soundOn); }}
            ></div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default SystemSettings